/**
 * Adds a product to the cart via the Shopify API.
 *
 * @param {Event} e - The event object.
 * @param {HTMLElement} el - The element that triggered the event.
 */

function _getProductById(e, el) {
  if (document.querySelector(".flickity-slider")) {
    let sliderPositionStart = document.querySelector(".flickity-slider").style.transform || "empty";
    let sliderPositionEnd;
    if (sliderPositionStart !== "empty") {
      setTimeout(() => {
        sliderPositionEnd = document.querySelector(".flickity-slider").style.transform;
        if (sliderPositionStart == sliderPositionEnd && !e.target.classList.contains("wk-icon")) {
          console.log(e.target);
          let formData = {
            'items': [
              {
                'id': el.dataset.product_id,
                'parent': el.parentElement.dataset.parent_name,
                'counter': el.parentElement.dataset.item_counter,
                'quantity': 1
              }
            ]
          };
          const productId = (formData.items[0].id);
          fetch(`/search/suggest.json?q=id:${productId}&resources[type]=product&limit=1`, {
            method: 'GET',
            headers: {
              'Content-Type': 'application/json'
            },
          })
            .then((resp) => {
              return resp.json();
            })
            .then((data) => {
              jQuery.getJSON(window.Shopify.routes.root + `products/${data.resources.results.products[0].handle}.js`, function (product) {
                const selectedProduct = product;
                getNewVariantDataCustomWhenSelected(selectedProduct);
                customHandleSelectProduct(selectedProduct, formData.items[0].parent, formData.items[0].counter);
              });
            })
        } else {
          return;
        }
      }, 150);
    }
  } else {
    let formData = {
      'items': [
        {
          'id': el.dataset.product_id,
          'parent': el.parentElement.dataset.parent_name,
          'counter': el.parentElement.dataset.item_counter,
          'quantity': 1
        }
      ]
    };
    const productId = (formData.items[0].id);
    fetch(`/search/suggest.json?q=id:${productId}&resources[type]=product&limit=1`, {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json'
      },
    })
      .then((resp) => {
        return resp.json();
      })
      .then((data) => {
        jQuery.getJSON(window.Shopify.routes.root + `products/${data.resources.results.products[0].handle}.js`, function (product) {
          const selectedProduct = product;
          getNewVariantDataCustomWhenSelected(selectedProduct);
          customHandleSelectProduct(selectedProduct, formData.items[0].parent, formData.items[0].counter);
        });
      })
  }

}

function _addMeToCart(e, el) {
  console.log('adding to cart');
  setTimeout(() => {
    const drawer = document.querySelector("#cart-drawer");
    drawer.show(); // Open the drawer and return a promise
  }, 300);

  if (e.currentTarget.dataset.name === 'shop-the-look-btn') {
    document.querySelector(".hidden-original-item-price").textContent = e.currentTarget.parentElement.querySelector(".hidden-compare-at-price") ? e.currentTarget.parentElement.querySelector(".hidden-compare-at-price .compare-at-price").textContent : "";
  } else if (e.currentTarget.dataset.name === 'inspo-page-btn') {
    document.querySelector(".hidden-original-item-price").textContent = e.currentTarget.parentElement.parentElement.querySelector(".inspo-analytic .compare-at-price") ? e.currentTarget.parentElement.parentElement.querySelector(".inspo-analytic .compare-at-price").textContent : "";
  } else {
    document.querySelector(".hidden-original-item-price").textContent = e.currentTarget.previousSibling.querySelector(".hidden-compare-at-price") ? e.currentTarget.previousSibling.querySelector(".hidden-compare-at-price .compare-at-price").textContent : "";
  }

  e = e || window.event;
  e.preventDefault();

  let formData = {
    items: [
      {
        id: el.dataset.variant_id,
        quantity: 1,
        flag: el.dataset.flag,
      },
    ],
  };

  fetch("/cart/add.js", {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify(formData),
  })
    .then((resp) => {
      return resp.json();
    })
    .then((data) => {
      getNewVariantDataCustom(data);
      customHandleAddToCart(data, formData.items[0].flag);
    })
    .then((data) => {
      document.documentElement.dispatchEvent(
        new CustomEvent("cart:refresh", {
          bubbles: true,
        })
      );
      setTimeout(() => {
        upsellNavigation();
        toggleUpsellVisibility();
      }, 800);
    })
    .catch((err) => {
      console.error("Error: " + err);
    });
}

function _removeMeFromCart(e, el) {
  document.querySelector(".hidden-original-item-price").textContent = e.currentTarget.nextSibling.querySelector('.remove-hidden-price') ? e.currentTarget.nextSibling.querySelector('.remove-hidden-price').textContent : "";

  e = e || window.event;
  e.preventDefault();
  let formData = {
    'items': [
      {
        'id': el.dataset.variant_id,
        'line': el.dataset.line,
        'quantity': e.currentTarget.parentElement.parentElement.querySelector(".quantity-selector__input").value
      }
    ]
  };
  const lineNumber = (formData.items[0].line - 1);

  $.ajax('/cart.js', {
    method: 'GET',
    dataType: 'json', // added data type
    headers: {
      'Content-Type': 'application/json'
    },
    success: function (response) {
      const removedItem = response.items[lineNumber];
      // console.log(removedItem);
      getNewVariantDataCustomWhenRemove(removedItem);
      customHandleRemoveFromCart(removedItem);
    }
  })
}

function _plusProdFromCart(e, el) {
  document.querySelector(".hidden-original-item-price").textContent = e.currentTarget.parentElement.parentElement.parentElement.parentElement.querySelector(".remove-hidden-price") ? e.currentTarget.parentElement.parentElement.parentElement.parentElement.querySelector(".remove-hidden-price").textContent : "";

  e = e || window.event;
  e.preventDefault();
  let formData = {
    'items': [
      {
        'id': el.dataset.variant_id,
        'line': el.dataset.line,
        'quantity': 1
      }
    ]
  };
  const lineNumber = (formData.items[0].line) - 1;

  $.ajax('/cart.js', {
    method: 'GET',
    dataType: 'json', // added data type
    headers: {
      'Content-Type': 'application/json'
    },
    success: function (response) {
      const addedItem = response.items[lineNumber]
      getNewVariantDataCustomWhenRemove(addedItem);
      customHandlePlusProdCart(addedItem);
    }
  })
}

function _minusProdFromCart(e, el) {
  document.querySelector(".hidden-original-item-price").textContent = e.currentTarget.parentElement.parentElement.parentElement.parentElement.querySelector(".remove-hidden-price") ? e.currentTarget.parentElement.parentElement.parentElement.parentElement.querySelector(".remove-hidden-price").textContent : "";

  e = e || window.event;
  e.preventDefault();
  let formData = {
    'items': [
      {
        'id': el.dataset.variant_id,
        'line': el.dataset.line,
        'quantity': 1
      }
    ]
  };
  const lineNumber = (formData.items[0].line) - 1;

  $.ajax('/cart.js', {
    method: 'GET',
    dataType: 'json', // added data type
    headers: {
      'Content-Type': 'application/json'
    },
    success: function (response) {
      const addedItem = response.items[lineNumber]
      getNewVariantDataCustomWhenRemove(addedItem);
      customHandleMinusProdCart(addedItem);
    }
  })
}

function _subscribeForm(formId) {
  customHandleSubscribe(formId);
}

function _backInStockForm() {
  productHandleBackInStock();
}